const inline_booking_panel_section = document.querySelector('.avvio-inline-booking-panel');
class Inline_Booking_Panel {
    constructor() {
        this.adultsInput = inline_booking_panel_section.querySelector('.js-adults');
        this.childrenInput = inline_booking_panel_section.querySelector('.js-children');
        this.input_checkin = inline_booking_panel_section.querySelector('.avvio-daterange__card-input-checkin');
        this.input_checkout = inline_booking_panel_section.querySelector('.avvio-daterange__card-input-checkout');
        this.submit = inline_booking_panel_section.querySelector('.js-submit');
        this.promocode = document.querySelector('[name="avvio-inline-booking-panel__promocode"]');
        this.offsetSelector = [".avvio-header", "#wpadminbar"];
    }

    getOffsetTop(selectorArray) {
        if (!selectorArray.length)
            return 0;
        return selectorArray.reduce((total, currentValue) => {
            let item = document.querySelector(currentValue);
            if (!item)
                return total;
            return total + item.offsetHeight;
        }, 0);
    }
    
    scrollStep() {
        var scrollableElementTop = inline_booking_panel_section.querySelector('.avvio-inline-booking-panel__search').getBoundingClientRect().top + window.scrollY;
        this.sectionOffsetTop = this.getOffsetTop([...this.offsetSelector]);
        window.scroll(0, scrollableElementTop - this.sectionOffsetTop);
    }
    
    scrollToTop() {
        setTimeout(() => {
            this.scrollStep();
        }, 100)
    }

    calenderCheckButtonClick() {
        var _self = this;
        var scrollButton = inline_booking_panel_section.querySelectorAll('.avvio-daterange__card-date');
        scrollButton.forEach((item) => {
            item.addEventListener('click', function() {
                _self.scrollToTop();
            })
        })
        
    }

    guest_number_change(divWrap) {
        var _self = this;
        var input = divWrap.querySelector('[type="number"]');
        var increaseValue = divWrap.querySelector('.js-increase-value');
        var decreasValue = divWrap.querySelector('.js-decreas-value');
        _self.increase_guest_value(input, increaseValue)
        _self.decreas_guest_value(input, decreasValue)
    }

    increase_guest_value(input, increaseValue) {
        increaseValue.addEventListener('click', function(){
            var value = parseInt(input.value, 10);
            value = isNaN(value) ? 0 : value;
            value > 3 ? value = 3 : '';
            value++;
            input.value = value;
        })
    }

    decreas_guest_value(input, decreasValue) {
        decreasValue.addEventListener('click', function(){
            var value = parseInt(input.value, 10);
            value = isNaN(value) ? 0 : value;
            
            if(input.dataset.field == 'totalAdults') {
                value < 2 ? value = 2 : '';
            } else {
                value < 1 ? value = 1 : '';
            }
            
            value--;
            input.value = value;
        })
    }

    booking_button_link() {
        var _self = this;
        _self.submit.addEventListener('click', function() {
            let url = document.getElementById('avvio-inline-booking-panel__url').value,
                modifyCheckIN = _self.input_checkin.value,
                modifyCheckOut = _self.input_checkout.value,
                adult = document.getElementById('avvio-inline-booking-panel__totalAdults').value,
                children = document.getElementById('avvio-inline-booking-panel__totalChildren').value,
                checkIN = document.getElementById('avvio-inline-booking-panel__checkIN').value,
                checkOut = document.getElementById('avvio-inline-booking-panel__checkOut').value,
                partya = "party="+ adult,
                promoCode = '',
                redirectURL = '';

            if(modifyCheckIN) {
                checkIN = modifyCheckIN;
            }

            if(modifyCheckOut) {
                checkOut = modifyCheckOut;
            }
            
            if(children != 0) {
                partya = "partya="+ adult;
                for (let i = 0; i < children; i++) {
                    partya += '%2C0';
                }
            }
            
            if(_self.promocode.value != '') {
                url = url.replace('results.html', 'index.php');
                url = url.replace('index.html', 'index.php');
                url = url.replace('results.php', 'index.php');
                
                promoCode = "&fw_submitted=1&av=search&searchPromoCode=" + _self.promocode.value;
            }

            var date1 = new Date(checkIN);
            var date2 = new Date(checkOut);
            var Difference_In_Time = date2.getTime() - date1.getTime();
            var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            redirectURL = url + '?checkin=' + checkIN +'&nights=' + Difference_In_Days + promoCode +'&'+ partya;
            // console.log(redirectURL);
            window.location = redirectURL
        })
    }

    init() {
        this.guest_number_change(this.adultsInput)
        this.guest_number_change(this.childrenInput)
        this.booking_button_link();
        this.calenderCheckButtonClick();
    }
}
if ( typeof(inline_booking_panel_section) != 'undefined' && inline_booking_panel_section != null ) {
    const inline_booking_panel = new Inline_Booking_Panel();
    inline_booking_panel.init();
}